import apiClient from 'api/config/apiClient'

export default {
  getOutpatientAuthorizationConsultation(payload) {
    return apiClient.request('authorization', payload)
  },
}
